/**
 * Somebody wound the recoil spring past its rating and wrote nothing down.
 */

import type { Affix } from '@/sim/items/affixContract';

export const OVERWOUND_SPRING = {
  id: 'overwoundSpring',
  slot: 'prefix',
  field: 'fireRate',
  direction: 1,
  label: 'Increased fire rate',
  nameWord: 'Overwound',
  ranges: {
    common: { min: 0.03, max: 0.07 },
    uncommon: { min: 0.07, max: 0.12 },
    rare: { min: 0.12, max: 0.18 },
    exotic: { min: 0.18, max: 0.26 },
  },
} as const satisfies Affix;
